import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

class ImageSnippet {
  constructor(
    public src: string,
    public file: File,
  ) {}
}

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false
})
export class FileUploadComponent implements OnInit {
  @Output() onUpload = new EventEmitter<any>();

  @Input() property = 'file';
  @Input() url: string;

  ngOnInit() {}

  selectedFile: ImageSnippet;

  constructor(private http: HttpClient) {}

  public uploadImage(image: File): Observable<Response> {
    const formData = new FormData();

    formData.append(this.property, image);

    return this.http.post<any>(this.url, formData);
  }

  processFile(imageInput: any) {
    const file: File = imageInput.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {
      this.selectedFile = new ImageSnippet(event.target.result, file);

      this.uploadImage(this.selectedFile.file).subscribe(
        res => {
          this.onUpload.emit(res);
        },
        err => {},
      );
    });

    reader.readAsDataURL(file);
  }
}
